module.exports = __webpack_public_path__ + "static/media/arrow-right-black.6ee9106f.svg";